import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UnconfirmedwalletService {

    constructor(private _http: HttpClient) { }

    getrecords(data) {
        return this._http.post(environment.api_url+'admin/order/unconfirmedwallet',data);
    }

}
